<template>
  <v-dialog v-model="show" width="800">
    <v-card>
      <v-card-title>{{ message.title }}</v-card-title>
      <v-container fluid>
        <div style="padding: 10px;">{{ message.content }}</div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      message: {}
    }
  },
  methods: {
    popup(item) {
      this.show = true
      this.message = item
    }
  }
}
</script>
